import { prepareDataPicture, ParserContentData, shuffleArray } from '@libs';

// Получение отзывов в блоке для кого
export const getReviews = (data) => {
  const items = ParserContentData.getItemsArray(data, { groupKey: 'home', blockKey: 'reviews' });

  return items.map((item) => {
    const { id, formData } = ParserContentData.getDataFromItem(item);
    const { name, text, avatar } = formData;
    return { id, name, text, avatar };
  });
};

// Получения картинок в блоке Gallery
export const getGalleryImages = (data) => {
  const items = ParserContentData.getItemsArray(data, { groupKey: 'home', blockKey: 'gallery' });

  const defaultImages = items.map((item) => {
    const { id, formData } = ParserContentData.getDataFromItem(item);
    const links = prepareDataPicture(Object.values(formData));
    const showId = id;

    return { id, showId, links };
  });

  return shuffleArray(defaultImages);
};

export const getGalleryEnImages = (data) => {
  const items = ParserContentData.getItemsArray(data, { groupKey: 'home', blockKey: 'gallery_en' });

  const defaultImages = items.map((item) => {
    const { id, formData } = ParserContentData.getDataFromItem(item);
    const links = prepareDataPicture(Object.values(formData));
    const showId = id;

    return { id, showId, links };
  });

  return shuffleArray(defaultImages);
};

// Получение картинки для блока DreamInterior
export const getDreamInteriorImage = (data) => {
  const item = ParserContentData.getItem(data, { groupKey: 'home', blockKey: 'footer', itemKey: 'image' });
  const { formData } = ParserContentData.getDataFromItem(item);

  return {
    links: prepareDataPicture(Object.values(formData)),
  };
};

// Получение картинки для блока DreamInterior
export const getRendersSlider = (data) => {
  const items = ParserContentData.getItemsArray(data, { groupKey: 'home', blockKey: 'renders_slider' });

  return items.map((item) => {
    const { id, alias, formData } = ParserContentData.getDataFromItem(item);

    return { id, alias, ...formData };
  });
};

export const getDirectSpeech = (data) => {
  const items = ParserContentData.getItemsArray(data, { groupKey: 'home', blockKey: 'direct-speech' });

  return items.map((item) => {
    const { id, alias, formData } = ParserContentData.getDataFromItem(item);

    return { id, alias, ...formData };
  });
};

export const getFaq = (data) => {
  const faq = ParserContentData.getItemsArray(data, { groupKey: 'home', blockKey: 'main_faq' });
  return faq
};

export const normalizeHome = (data = {}) => {
  // const reviews = getReviews(data);
  // const gallery = getGalleryImages(data);
  // const gallery_en = getGalleryEnImages(data);
  // const dreamInteriorImage = getDreamInteriorImage(data);
  // const rendersSlider = getRendersSlider(data);
  const directSpeech = getDirectSpeech(data);
  const main_faq = getFaq(data);

  return { directSpeech, main_faq };
};
